import { SearchQueryParams } from 'containers/SearchField';
import { useAppDispatch } from 'store';
import { v1 as uuidv1 } from 'uuid';
import { actions as airfareSearchActions } from 'reducers/airfare-search';
import { useRouter } from 'next/router';
import { findKeyByRewriteUrl } from 'urlTranslations';

const useNewSearch = (query: SearchQueryParams) => {
  const dispatch = useAppDispatch();
  const router = useRouter();

  const handleNewSearch = () => {
    const sessionId = uuidv1();
    const newQuery = { ...query };
    if ('b' in newQuery) delete newQuery['b'];
    if ('fs_s' in newQuery) delete newQuery['fs_s'];
    if ('flightNumber' in newQuery) delete newQuery['flightNumber'];
    dispatch(airfareSearchActions.setOutboundDetails(null));
    dispatch(airfareSearchActions.updateSessionId(sessionId));

    router.push({
      pathname: findKeyByRewriteUrl('/results/', router.locale),
      query: {
        ...newQuery,
        r: sessionId,
      },
    });
  };

  return {
    handleNewSearch,
  };
};

export default useNewSearch;
